import { Col, Grid, Row, theme } from 'antd';
import type { BannerActionDetailOut } from '@/api/generated/schemas';
import { BannerActionBasicInfoCard } from '@/components/user_catalog/banner_actions/BannerActionBasicInfoCard';
import { BannerActionPreviewCard } from '@/components/user_catalog/banner_actions/BannerActionPreviewCard';
import type { CreativeModel } from '@/components/user_catalog/banner_actions/bannerActionPreview';

interface BannerActionGeneralTabProps {
  record: BannerActionDetailOut;
  model: CreativeModel;
}

export const BannerActionGeneralTab = ({
  record,
  model,
}: BannerActionGeneralTabProps) => {
  const { token } = theme.useToken();
  const screens = Grid.useBreakpoint();

  return (
    <Row gutter={[token.margin, token.margin]}>
      <Col flex="1 1 480px">
        <BannerActionBasicInfoCard record={record} model={model} />
      </Col>
      <Col flex={screens.lg ? '0 1 440px' : '0 1 300px'}>
        <BannerActionPreviewCard model={model} name={record.name} />
      </Col>
    </Row>
  );
};
